
export default {
	name: 'newsletterSignup',
	components: {
	}, 
  mixins: [
  ],
	props: [
	],
	data() {
		return {
      email: '',
      emailError: 'Email aint valid',
      formSubmitted: false, // Track if the form has been submitted
      validSubmit: false // Track if the form has been successfully submitted
		};
	},
	methods: {
		footerSubmit(){
      // Set formSubmitted to true to trigger validation
      this.formSubmitted = true;

      if (this.isFormValid) {
        // Form submission logic
        console.log('Form submitted with email:', this.email);
        
        // Get the form data
        exponea.identify({
          email_id: this.email
        },{
          source: 'footer',
          email: this.email,
        });
        
        exponea.track("consent", {
          action: "accept",
          category: "Email Marketing",
          valid_until: "unlimited",
          message: "This consent was tracked from the footer"
        });


        exponea.track('footer', {
          source: 'footer',
        });
        

        // Set submitted to true to display success message
        this.validSubmit = true;
      } else {
        // Handle form submission when invalid
        console.log('Form submission blocked due to validation errors.');
      } 
    },
		validateEmail() {
      // Regular expression for email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!this.email) {
        this.emailError = 'Email is required.';
      } else if (!emailRegex.test(this.email)) {
        this.emailError = 'Invalid email format.';
      } else {
        this.emailError = '';
      }
    }
	},
  computed: {
    isFormValid() {
      this.validateEmail(); // Validate on form submission
      return this.email && !this.emailError;
    }
  },
	mounted() {
	}

};